import {Component} from "../interface/component";

export class VideoComponent implements Component {

    private $root:JQuery;
    private $placeholder:JQuery;
    private $button:JQuery;
    private $player:JQuery;
    private $inner:JQuery;

    constructor(elem:HTMLElement) {
        this.$root = $(elem);
        this.$placeholder = this.$root.find('.js-video-placeholder');
        this.$button = this.$root.find('.js-video-button');
    }

    init() {
        this.bindUI();
    }

    private bindUI() {
        this.$root.on({click: this.videoClick});
        this.$placeholder.on({click: this.videoClick.bind(this)});
    }

    private videoClick = (ev: Event) => {
        ev.stopPropagation();
        if (!this.$player) {
            let source = this.$placeholder.attr('data-video');
            this.$player =  $('<iframe src="' + source + '" frameborder="0" allow="autoplay" allowfullscreen wmode="opaque"></iframe>');
            this.$player.insertAfter( this.$placeholder );
            this.$button.addClass('is-playing');
            this.$inner.addClass('hide-icon');
        } else {
            this.$button.removeClass('is-playing');
            this.$player.remove();
            this.$player = null;
            this.$inner.removeClass('hide-icon');
        }
    }
}
